import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=31bdafe2&scoped=true&"
var script = {}
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=31bdafe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bdafe2",
  null
  
)

export default component.exports